import styled from '@emotion/styled';
import { Menu } from '@mui/material';

const RichTooltip = styled(Menu)`
    margin: ${({ theme }) => theme.spacing(4)};
    .MuiPaper-root {
        border-radius: 12px;
    }
`;

export { RichTooltip };
